export enum SidenavState {
  EXPANDED,
  COLLAPSED,
  OVER,
}
